import React, {useEffect, useState} from 'react';

import Banner from 'web/components/banner';
import assetPath from 'web/helpers/asset_path';

export const BANNER_PATH = '/refer-a-friend ';

interface HomeBannerProps {
  minWidth?: number;
  noMargin?: boolean;
}
const HomeBanner: React.FC<HomeBannerProps> = ({minWidth = 720, noMargin}) => {
  const [width, setWidth] = useState(typeof window !== 'undefined' ? window.innerWidth : minWidth);
  const handleClickCard = (): void => {
    window.location.assign(BANNER_PATH);
  };

  useEffect(() => {
    const handleResize = (): void => setWidth(window.innerWidth);
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  });

  return (
    <div className="basket-view__header home-banner" style={{margin: noMargin ? 0 : '0 auto'}}>
      <Banner
        imgSource={
          <img
            alt="Banner logo"
            data-testid="banner-logo"
            src={`${assetPath('/img/svg/icons/ge-g-logo-white.svg')}?auto=format`}
            className="banner__icon"
            style={{cursor: 'pointer'}}
            onClick={handleClickCard}
          />
        }
        title={
          <p data-testid="banner-title">
            Help us grow the Good Eggs community! Give a friend $50 their first order and get $60
            off your next order.&nbsp;
            {width < minWidth && <br />}
            <a href={BANNER_PATH} data-testid="cta-link">
              Click here.
            </a>
          </p>
        }
        showInfoButton={false}
      />
    </div>
  );
};

export default HomeBanner;
